import { render, staticRenderFns } from "./PersonhoodHomePage.vue?vue&type=template&id=6271b1fe&"
import script from "./PersonhoodHomePage.vue?vue&type=script&lang=js&"
export * from "./PersonhoodHomePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports